<span kltNegativeFormatter [value]="value">
  {{
    value
      | localeNumber: decimalPoints : minimumDecimalPoints : locale
      | negativeFormatter
  }}<ng-content></ng-content>
</span>
